  <template>
  <div>
    <div class="modal-user modal-xl">
      <div style="text-align: right" class="modal-close" @click="closeModal">
        &#10006;
      </div>
      <div class="title">
        <h3 class="modal-title text-center">Edit insights</h3>
      </div>
      <div class="body modal-scroll">
        <div class="row">
          <div class="col-md-6">
            <div class="d-flex mb-3">
              <label class="typo__label admin-label mt-3">Select user</label>
              <multiselect
                v-model="form.selectedUser"
                :options="getEmail"
                :class="{ 'is-invalid': form.errors.has('email') }"
                :searchable="false"
                :close-on-select="false"
                :show-labels="false"
                :custom-label="customLabel"
                track-by="id"
                placeholder="Pick a value"
              />

              <!-- <has-erroron save insight body :form="form" field="email" /> -->
            </div>
            <!-- ... Other fields ... -->
            <div class="form-group d-flex mb-3">
              <label class="col-form-label admin-label text-md-start"
                >Title</label
              >
              <input
                v-model="form.title"
                :class="{ 'is-invalid': form.errors.has('title') }"
                class="form-control"
                type="text"
                name="title"
                placeholder="Title insight"
              />
              <has-error :form="form" field="title" />
            </div>

            <div class="form-group d-flex mb-3">
              <label class="col-form-label admin-label text-md-start"
                >Insight Type</label
              >
              <select
                class="form-select custom-select"
                aria-label="Default select example"
                v-model="form.selectedInsightType"
              >
                <option value="Regimen">Regimen</option>
                <option value="Product">Product</option>
              </select>
            </div>

            <div class="form-group d-flex mb-3">
              <label class="col-form-label admin-label text-md-start"
                >Description</label
              >

              <textarea
                v-model="form.description"
                :class="{ 'is-invalid': form.errors.has('description') }"
                class="form-control"
                type="text"
                placeholder="Description"
                id="floatingTextarea2"
                style="height: 100px"
              ></textarea>

              <has-error :form="form" field="description" />
            </div>

            <div class="form-group d-flex mb-3">
              <label class="col-form-label text-md-start admin-label"
                >Rating</label
              >
              <select
                class="form-select custom-select"
                aria-label="Default select example"
                v-model="form.rating"
              >
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>
          </div>

          <div class="col-md-6">
            <!-- ... Other fields ... -->
            <div class="d-flex mb-3">
              <label class="typo__label admin-label">Select regimens</label>
              <multiselect
                v-model="form.regimens"
                :options="getRegimenName"
                :multiple="true"
                :taggable="true"
                tag-placeholder="Add this as new tag"
                placeholder="Search or add a tag"
                label="value"
                track-by="value"
                @tag="addTag"
                @remove="removeTag"
              />
              <has-error :form="form" field="nameRegimen" />
            </div>

            <div
              style="margin-left: auto; margin-right: auto"
              class="col-sm-12 d-block justify-content-center"
            >
              <div
                class="week-counter d-flex gap-5 justify-content-center mt-5"
              >
                <div class="minus-button" @click="decreaseWeekCount">
                  <MinusSvg />
                </div>
                <div class="counter d-flex align-items-center">
                  <div>
                    <h3 class="m-0">{{ form.weekCount }}</h3>
                  </div>
                </div>
                <div class="plus-button" @click="increaseWeekCount">
                  <PlusSvg />
                </div>
              </div>
              <div class="justify-content-center d-flex text-center mt-2 mb-5">
                <span style="font-size: 10px; color: #613975">X For week</span>
              </div>
              <div
                class="week-days d-flex align-items-center mt-1 justify-content-center gap-4"
              >
                <div class="select-day">
                  <CheckboxWeek
                    v-if="selectedDays.length > 0"
                    :date="days"
                    :selectedDate="selectedDays"
                    @days="setDay"
                  />
                </div>
              </div>
              <div class="d-flex mt-2">
                <span class="mt-2 mb-3 frequency"
                  >Select the frequency and days of week for this element
                  adjustment</span
                >
              </div>
            </div>

            <!-- ... Other fields ... -->

            <div class="form-group d-flex mb-3">
              <label class="col-form-label text-md-start admin-label"
                >Duration</label
              >
              <input
                v-model="form.duration"
                :class="{ 'is-invalid': form.errors.has('duration') }"
                class="form-control"
                type="number"
                name="duration"
                placeholder="Duration"
              />
              <has-error :form="form" field="duration" />
            </div>

            <div class="d-flex">
              <label class="typo__label mt-3 admin-label"
                >Select products</label
              >
              <multiselect
                v-model="form.products"
                :options="getProductsName"
                :multiple="true"
                :taggable="true"
                tag-placeholder="Add this as new tag"
                placeholder="Search or add a tag"
                label="name"
                track-by="name"
                @tag="addTag"
              />
              <has-error :form="form" field="nameProducts" />
            </div>

            <div class="form-group d-flex my-3">
              <label class="col-form-label text-md-start admin-label"
                >Approve Insight</label
              >
              <div class="d-flex flex-wrap">
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    id="approveOption1"
                    value="temp"
                    v-model="form.approve"
                  />
                  <label class="form-check-label" for="approveOption1"
                    >Temporarily</label
                  >
                </div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    id="approveOption2"
                    value="reject"
                    v-model="form.approve"
                  />
                  <label class="form-check-label" for="approveOption2"
                    >Reject</label
                  >
                </div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    id="approveOption3"
                    value="approve"
                    v-model="form.approve"
                  />
                  <label class="form-check-label" for="approveOption3"
                    >Permanently</label
                  >
                </div>
              </div>
            </div>
            <!-- ... Other fields ... -->
          </div>
        </div>
        <div class="footer">
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click="editInsightData"
            >
              Update Insight
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
    
    <script>
import { mapActions, mapGetters } from "vuex";
import Multiselect from "vue-multiselect";
import PlusSvg from "@/components/SVG/Plus";
import MinusSvg from "@/components/SVG/Minus";
import CheckboxWeek from "@/components/CheckboxWeek";
import Swal from "sweetalert2";
import Form from "vform";
import axios from "axios";

export default {
  name: "EditInsightModalVue",
  props: {
    insightId: {
      type: Number,
    },
  },
  components: { PlusSvg, MinusSvg, CheckboxWeek, Multiselect },

  data() {
    return {
      form: new Form({
        title: "",
        regimens: [],
        email: "",
        products: [],
        weekCount: 1,
        weekDays: [],
        approve: "",
        user_id: "",
        selectedUser: null,
        selectedInsightType: "",
      }),
      show: false,
      selectedDays: [],
    };
  },

  computed: {
    ...mapGetters(["adminData", "allRegimenElements", "shop", "days"]),

    getEmail() {
      return this.adminData
        ? this.adminData.map((user) => {
            return { id: user.id, email: user.email };
          })
        : "";
    },

    getRegimenName() {
      return this.allRegimenElements
        ? this.allRegimenElements.map((name) => {
            return {
              id: name.id,
              value: name.element_name,
            };
          })
        : "";
    },

    getProductsName() {
      return this.shop && this.shop.products
        ? this.shop.products.map((product) => {
            return {
              id: product.id,
              name: product.name || "No title",
              tags: product.tags || [],
              image: product.images || "",
            };
          })
        : [];
    },
  },

  async mounted() {
    await this.fetchInsightData();
  },

  created() {
    this.getAllRegimen();
    this.getAllProducts();
    this.getUserDate();
  },

  methods: {
    ...mapActions([
      "getAllInsight",
      "fetchAllRegimenElements",
      "fetchShopProducts",
      "updateInsights",
      "getCurrentWeek",
      "fetchInsights",
      "fetchUser",
    ]),
    async fetchInsightData() {
    },
    fetchAllInsight() {
      return this.getAllInsight();
    },
    decreaseWeekCount() {
      if (this.form.weekCount > 1) {
        this.form.weekCount -= 1;
      }
    },

    increaseWeekCount() {
      if (this.form.weekCount < 7) {
        this.form.weekCount += 1;
      }
    },

    async fetchUserData() {
      try {
        const userDataResponse = await this.$store.dispatch("fetchUser")
        this.$set(this.form, 'user_id', userDataResponse.id);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    },

    customLabel(option) {
      return option.email;
    },
    validateWeekdays() {
      const selectedDaysCount = this.form.weekDays.length;

      if (selectedDaysCount !== this.form.weekCount) {
        this.form.errors.add(
          "weekDays",
          "Please select the correct number of weekdays."
        );
      } else {
        this.form.errors.remove("weekDays");
      }
    },

    addTag(newTag) {
      this.form.regimens.push(newTag);
    },
    removeTag(removedTag) {
      const index = this.form.regimens.findIndex(
        (tag) => tag.value === removedTag
      );
      if (index !== -1) {
        this.form.regimens.splice(index, 1);
      }
    },
    setDay(data) {
      this.form.weekDays = data;
      this.validateWeekdays();
    },

    getAllRegimen() {
      this.fetchAllRegimenElements();
    },

    getAllProducts() {
      this.fetchShopProducts();
    },

    getUserDate() {
      this.getCurrentWeek();
    },

    closeModal: function () {
      window.addEventListener("click", (event) => {
        if (event.target.classList.contains("modal-close")) {
          this.$store.commit("HIDE_MODAL");
        }
      });
    },
    fetchInsightData() {
      const apiUrl = `${process.env.API_URL}/get-insight/${this.insightId}`;
      axios
        .post(apiUrl)
        .then((response) => {
          const insightData = response.data;
          this.form.title = insightData.title;
          this.form.description = insightData.description;
          this.form.regimens = insightData.regimens.map((regimen) => ({
            id: regimen.elements.id,
            value: regimen.elements.element_name,
          }));
          this.form.products = insightData.products;
          this.form.rating = insightData.rating;
          const matchingUser = this.adminData.find(
            (user) => user.id === insightData.select_user
          );
          this.form.selectedUser = matchingUser
            ? { id: matchingUser.id, email: matchingUser.email }
            : null;

          this.form.selectedUser = { ...this.form.selectedUser };
          this.form.weekCount = insightData.week_duration;
          const dayDurationArray = JSON.parse(insightData.day_duration).map(
            (dateString) => new Date(dateString)
          );
          this.selectedDays = dayDurationArray;
          this.form.selectedInsightType = insightData.insight_type;
          if (
            insightData.approved_at !== null &&
            insightData.approved_at !== ""
          ) {
            this.form.approve = "approve";
          } else if (
            insightData.temporary_at !== null &&
            insightData.temporary_at !== ""
          ) {
            this.form.approve = "temp";
          } else if (
            insightData.rejected_at !== null &&
            insightData.rejected_at !== "" &&
            (insightData.approved_at === null || insightData.approved_at === "")
          ) {
            this.form.approve = "reject";
          }
        })
        .catch((error) => {
          console.error("Error fetching insight data:", error);
        });
    },

    editInsightData() {
      const apiUrl = `${process.env.API_URL}/update-insight/${this.insightId}`;
      const updateData = {
        title: this.form.title,
        description: this.form.description,
        rating: this.form.rating,
        selectedUser: this.form.selectedUser,
        insight_type: this.form.selectedInsightType,
        regimens: this.form.regimens,
        duration: this.form.duration,
        products: this.form.products,
        weekCount: this.form.weekCount,
        weekDays: this.form.weekDays,
        approve: this.form.approve,
        user_id: this.form.user_id,
      };

      axios
        .post(apiUrl, updateData)
        .then((response) => {
          this.$store.commit("HIDE_MODAL");

          Swal.fire({
            title: "Successfully!",
            text: "Insight has been updated successfully.",
            icon: "success",
          }).then(() => {
            this.form.title = "";
            this.form.regimens = [];
            this.form.email = "";
            this.form.products = [];
            this.form.weekCount = 1;
            this.form.weekDays = [];
            console.log("Modal closed");
          });
          this.fetchAllInsight();
        })
        .catch((error) => {
          console.error("API call error:", error);
        });
    },
  },
};
</script>
  
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.modal-title {
  color: #603975;
  font-family: "Poppins";
  font-size: 30px;
  font-weight: 700;
  margin-bottom: 20px;
  position: relative;
  top: -22px;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}
.form-control {
  color: #212529;
  border-radius: 3px;
  border: 1px solid #603975;
  background: #faf8fb;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.5) inset;
  box-shadow: none;
  resize: none;
  padding: 12px;
}
span .multiselect__tags {
  border: 1px solid #603975 !important;
  padding: 12px !important;
  background-color: #faf8fb !important;
  width: 100px !important;
}
.form-select {
  border: 1px solid #603975 !important;
  border-radius: 5px;
  padding: 12px;
  background-color: #faf8fb;
}
.form-check-input[type="radio"] {
  border-radius: 5px;
}
.form-check-input {
  border: 1px solid #603975;
}
.form-check-label {
  color: #613975;
  font-size: 14px;
  font-weight: 500;
}
.select-day div {
  margin-right: 15px !important;
}
.counter h3 {
  color: #603975;
}
.form-check-input:checked {
  background-color: #603975;
  border-color: #603975;
}
.form-check-input {
  width: 18px;
  height: 18px;
}
.form-check-input:focus {
  border-color: #613975;
  outline: 0;
  box-shadow: none;
}
.form-control:focus {
  border-color: #613975;
  box-shadow: none;
}
.multiselect__placeholder {
  margin-bottom: 0;
}
.multiselect__select {
  top: 8px !important;
}
.modal-scroll {
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
}
.multiselect__option--selected {
  font-weight: 400 !important;
}
.frequency {
  color: #979797;
  font-size: 10px;
  font-style: italic;
  font-weight: 400;
  line-height: normal;
}
</style>
  


// WEBPACK FOOTER //
// src/components/modals/AdminModals/EditInsightModal.vue